<!--
<div class="modal-header">
  <h4 class="modal-title">Preview</h4>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss()">
  </button>
</div>
-->

<div class="modal-body" [innerHTML]="html"></div>